import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Loader2, Award, Shield, ArrowLeft, Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProfessionalsDirectory = () => {
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/profile/public-list`)
      .then(r => setProfessionals(r.data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = professionals.filter(p =>
    p.full_name?.toLowerCase().includes(search.toLowerCase()) ||
    p.specialty?.toLowerCase().includes(search.toLowerCase()) ||
    p.official_college?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen" style={{ background: '#F6F5F0' }}>
      <header style={{ background: '#0B1D3A' }}>
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <h1 className="text-xl font-bold" style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#fff', letterSpacing: '2px' }}>
              CERTILEX<sup style={{ fontSize: '0.5em' }}>&reg;</sup>
            </h1>
          </Link>
          <Link to="/" className="flex items-center gap-1 text-sm" style={{ color: '#C5A55A' }}>
            <ArrowLeft className="w-4 h-4" /> Inicio
          </Link>
        </div>
      </header>

      <div className="container mx-auto px-6 py-8 max-w-4xl">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold" style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#0B1D3A' }}>
            Directorio de Profesionales
          </h2>
          <p className="mt-2" style={{ color: '#4A4A5A' }}>Profesionales con competencias acreditadas mediante acta notarial</p>
        </div>

        <div className="relative max-w-md mx-auto mb-8">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            placeholder="Buscar por nombre, especialidad o colegio..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="pl-10"
            style={{ borderColor: '#E2DDD3' }}
            data-testid="directory-search"
          />
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin" style={{ color: '#C5A55A' }} />
          </div>
        ) : filtered.length === 0 ? (
          <p className="text-center py-12" style={{ color: '#9ca3af' }}>
            {professionals.length === 0 ? 'No hay profesionales con perfil publico todavia.' : 'No se encontraron resultados.'}
          </p>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {filtered.map(p => (
              <Link key={p.id} to={`/perfil/${p.id}`} style={{ textDecoration: 'none' }}>
                <Card className="hover:shadow-lg transition-shadow" style={{ border: '1px solid #E2DDD3' }}>
                  <CardContent className="p-5 flex items-center gap-4">
                    <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ background: '#0B1D3A' }}>
                      <span style={{ color: '#C5A55A', fontSize: '1.1rem', fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 }}>
                        {p.full_name?.split(' ').map(n => n[0]).join('').slice(0, 2)}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <h3 className="font-semibold truncate" style={{ color: '#0B1D3A' }}>{p.full_name}</h3>
                        {p.is_certified && <Award className="w-4 h-4 flex-shrink-0" style={{ color: '#C5A55A' }} />}
                      </div>
                      <p className="text-sm truncate" style={{ color: '#4A4A5A' }}>{p.specialty}</p>
                      <div className="flex items-center gap-2 mt-1">
                        {p.collegiate_number && (
                          <span className="text-xs flex items-center gap-1" style={{ color: '#9ca3af' }}>
                            <Shield className="w-3 h-3" /> {p.collegiate_number}
                          </span>
                        )}
                        {p.official_college && (
                          <span className="text-xs" style={{ color: '#9ca3af' }}>{p.official_college}</span>
                        )}
                      </div>
                      {p.certified_competencies?.length > 0 && (
                        <div className="flex flex-wrap gap-1 mt-2">
                          {p.certified_competencies.slice(0, 3).map((c, i) => (
                            <Badge key={i} className="text-xs px-2 py-0" style={{ background: 'rgba(197,165,90,0.15)', color: '#0B1D3A' }}>{c}</Badge>
                          ))}
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfessionalsDirectory;
